import React, {useEffect, useState} from 'react';
import {BASE_URL_WEB} from '../../../utility/constants';
import {AxiosHelperPortal} from '../../../utility/helperFunctions';
import {bookingLocationLabel} from '../../../utility/bookingLocation';
import {BookingLocation} from '../../BookingDetails';

const AppointmentBookingLocation = ({companyId, trainerId, branchId}) => {
  const [result, setResult] = useState(null);
  const [retry, setRetry] = useState(0);
  const contextKey = JSON.stringify([companyId, trainerId, branchId]);

  useEffect(() => {
    let active = true;
    setResult(null);
    if (!companyId || !trainerId || !branchId) return;
    const params = new URLSearchParams({companyId, trainerId, branchId});
    AxiosHelperPortal(`${BASE_URL_WEB}client-booking-location?${params}`, 'get')
      .then(response => {
        if (active) {
          const label = bookingLocationLabel({savedLocation: response?.data?.location});
          setResult({contextKey, location: response?.data?.location, label, failed: !label});
        }
      })
      .catch(() => {
        if (active) setResult({contextKey, failed: true});
      });
    return () => {
      active = false;
    };
  }, [companyId, trainerId, branchId, contextKey, retry]);

  if (!companyId || !trainerId || !branchId) {
    return <p>Choose a coach and branch to see the location.</p>;
  }
  if (result?.contextKey !== contextKey) {
    return <p role="status">Loading session location…</p>;
  }
  if (result.failed) {
    return (
      <div role="alert">
        Unable to load the session location.
        <button type="button" className="btn btn-link" onClick={() => setRetry(value => value + 1)}>
          Retry
        </button>
      </div>
    );
  }
  return <BookingLocation booking={{savedLocation: result.location}} />;
};

export default AppointmentBookingLocation;
